import {FC, useRef} from 'react'

import {BlogPreview} from '@/components/blog/BlogPreview'
import {BLOGS_PER_PAGE} from '@/components/blog/constants'
import {usePagination} from '@/components/common/content/pagination/hooks'
import {Pagination} from '@/components/common/content/pagination/Pagination'
import {Text, TextVariant} from '@/components/common/content/Text'
import {useMobile} from '@/components/context/MobileProvider'
import {getAboutUsContent} from '@/content/aboutUs'
import {useTranslation} from '@/i18n'
import {HEADER_HEIGHT_DESKTOP} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {getBlogOverviewPath} from '@/utils/blog/helpers'
import {BlogOverview} from '@/utils/contentful'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type ProfileBlogsProps = {
  blogs: BlogOverview[]
}

export const ProfileBlogs: FC<ProfileBlogsProps> = ({blogs}) => {
  const {t} = useTranslation()
  const {newestArticlesTitle} = getAboutUsContent().profilePage
  const isMobile = useMobile()

  const sectionRef = useRef<HTMLDivElement>(null)
  const hasPagination = blogs.length > BLOGS_PER_PAGE
  const {currentPage, setCurrentPage, numberOfPages, currentItems} = usePagination(
    blogs,
    BLOGS_PER_PAGE,
  )

  const sectionOffset = parseInt(isMobile ? '0px' : HEADER_HEIGHT_DESKTOP, 10) + 100

  return (
    <>
      <div className="wrapper">
        <Text variant={TextVariant.h4} element="h2">
          {t(newestArticlesTitle)}
        </Text>
        <div className="blogs" ref={sectionRef}>
          {currentItems.map((blog) => (
            <BlogPreview key={blog.slug} blog={blog} linkHref={getBlogOverviewPath(blog)} />
          ))}
          {hasPagination && (
            <div className="pagination">
              <Pagination
                sectionRef={sectionRef}
                sectionOffset={sectionOffset}
                currentPage={currentPage}
                numberOfPages={numberOfPages}
                setCurrentPage={setCurrentPage}
              />
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          margin: 0 ${theme.spacing[6]};
        }
        .blogs {
          margin-top: ${theme.spacing[5]};
        }
        .pagination {
          margin-top: ${theme.spacing[6]};
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .wrapper {
            margin: 0 ${theme.spacing[5]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            margin: 0;
          }
        }
      `}</style>
    </>
  )
}
